import { p as proxyCustomElement, H, h, d as Host } from './p-ae815584.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";
const CosmosIconCreateStyle0 = cosmosIconCss;

const CosmosIconCreate$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconCreate extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.ariaLabel = undefined;
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '764d1575962d0d37a831fedf36808a692f7c8596', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: 'b9786b04f6fe6c5493a633be671bb6a8e78c8881', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '20ab12ffe7fa7089a107eef06909b9f3174a4cb8', d: "M19.911 4.455c.136-.136.114-.379-.049-.542l-1.768-1.774c-.163-.164-.405-.186-.54-.05l-1.228 1.232 2.357 2.366 1.228-1.232Zm-4.47-.246-6.483 6.505-.935 2.731a.418.418 0 0 0 .523.534l2.77-.899 6.483-6.506-2.358-2.365Z", fill: "currentColor" }), h("path", { key: '0702c452dab2e1eff13aacaf6d71ad4951981210', d: "M16.5 17.5V11a.5.5 0 0 1 .5-.5h.5a.5.5 0 0 1 .5.5v7.5a.5.5 0 0 1-.5.5h-14a.5.5 0 0 1-.5-.5v-14a.5.5 0 0 1 .5-.5H11a.5.5 0 0 1 .5.5V5a.5.5 0 0 1-.5.5H4.5v12h12Z", fill: "currentColor" }))));
    }
    static get style() { return CosmosIconCreateStyle0; }
}, [1, "cosmos-icon-create", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-create"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-create":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconCreate$1);
            }
            break;
    } });
}

const CosmosIconCreate = CosmosIconCreate$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconCreate, defineCustomElement };
